import * as constants from '../constants';

const ressellers = (state = null, action) => {
  switch (action.type) {
    default: {
      return state;
    }
    case constants.FETCH_RESSELLERS_SUCCESS: {
      let ressellers = action.payload.slice();
      return ressellers;
    }
    case constants.API_OUT_OF_DATE:
    case constants.ACTIVATE_LANGUAGE: {
      return null;
    }
  }
}
export default ressellers;



// WEBPACK FOOTER //
// ./src/store/reducers/ressellers.js